import axios from 'axios';
import { mapKeys, camelCase } from 'lodash';
import pathfinder from '@fiverr-private/pathfinder';
import { toFormData } from '../../utils/toFormData';
import { logError } from '../../utils/logError';
import { SignInPayload, SignInResponse, SignInResult } from './signIn.types';

export const signIn = async ({ login, password, funnel }: SignInPayload): Promise<SignInResult> => {
    try {
        const url = pathfinder('user_sessions');
        const formData = toFormData({
            'user_session[login]': login,
            'user_session[password]': password,
            funnel,
        });

        const { data } = await axios.post<SignInResponse>(url, formData);

        return mapKeys(data, (_, key) => camelCase(key)) as unknown as SignInResult;
    } catch (error) {
        logError({
            message: 'Error during sign in',
            error,
        });

        throw error;
    }
};
